export const episodes = [
  {
    id: "1",
    number: 1,
    title: "搬回老宅",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20showing%20a%20young%20couple%20carrying%20cardboard%20boxes%20into%20an%20old%20chinese%20courtyard%20house%20at%20dusk%2C%20nostalgic%20warm%20amber%20lighting%2C%20muted%20earthy%20tones%2C%20soft%20film%20grain%2C%20emotional%20atmosphere%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-01&orientation=portrait",
    airDate: "2024-03-01",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "周雨桐", "陈志远"],
    summary: "儿媳林晓梅第一次踏进陈家老宅，一家人的新生活从这扇旧木门开始。",
    plot: "春寒料峭的三月，陈建国带着妻子林晓梅和儿子陈小宇搬回了父亲陈老根住了大半辈子的老宅。院子里的老槐树刚冒出嫩芽，陈老根却站在门口半天没让开路——他对这个来自南方的儿媳始终有些说不清的戒备。林晓梅放下行李就挽起袖子收拾屋子，默默把陈老根最爱的那把旧藤椅擦得干干净净。第一晚，一家人坐在堂屋的旧方桌前吃饭，没人知道，这顿饭之后，这个家将迎来怎样的磨合与和解。",
    tags: ["家庭", "冲突", "温情"],
    characterIds: ["chen-laogen", "lin-xiaomei", "chen-jianguo", "chen-xiaoyu"],
  },
  {
    id: "2",
    number: 2,
    title: "第一顿团圆饭",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20multi%20generational%20chinese%20family%20gathered%20around%20a%20round%20dining%20table%20full%20of%20home%20cooked%20dishes%2C%20warm%20lantern%20lighting%2C%20muted%20red%20and%20amber%20tones%2C%20nostalgic%20cozy%20atmosphere%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-02&orientation=portrait",
    airDate: "2024-03-02",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "王秀兰", "周雨桐"],
    summary: "王桂芬张罗了一桌好菜，却在饭桌上因为一盘菜的口味闹了个不愉快。",
    plot: "为了欢迎儿媳，王桂芬一大早就在厨房里忙活，做了满满一桌陈家老口味的菜。林晓梅尝了一口咸得发苦的红烧肉，笑着咽下去，却被细心的陈小宇当场戳破。陈老根脸一沉，筷子往桌上一放，堂屋里的气氛瞬间凝固。陈建国左右为难，一边是父亲，一边是妻子，只能埋头扒饭。最后还是陈小宇一句“奶奶做的菜和妈妈做的一样香”把大家逗笑了，一家人勉强吃完了这顿团员饭。",
    tags: ["温情", "饮食", "家庭"],
    characterIds: ["chen-laogen", "wang-guifen", "lin-xiaomei", "chen-xiaoyu", "chen-jianguo"],
  },
  {
    id: "3",
    number: 3,
    title: "生活习惯的碰撞",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20comparing%20an%20old%20fashioned%20chinese%20courtyard%20kitchen%20with%20modern%20minimalist%20appliances%20side%20by%20side%2C%20split%20emotional%20scene%2C%20soft%20natural%20daylight%2C%20muted%20warm%20neutral%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-03&orientation=portrait",
    airDate: "2024-03-03",
    duration: "45分钟",
    director: "张建安",
    cast: ["周雨桐", "陈志远", "赵雅琴"],
    summary: "南方儿媳的精致与北方老宅的粗糙正面相撞，小姑陈晓丽成了意外的调解人。",
    plot: "林晓梅给厨房装了一台净水器，又买来分格的调料盒，把陈老根用了二十年的搪瓷盆收进了柜子。陈老根发现后气得直跺脚，觉得这个儿媳是在嫌弃自己的家。小姑陈晓丽放学回家撞见这一幕，没有像往常一样躲开，反而坐下来跟父亲讲道理：“哥嫂是想让家里更好，爸你别总把人往坏处想。”一番话让陈老根沉默了，也让林晓梅第一次觉得，这个家里有人愿意懂她。",
    tags: ["冲突", "代际", "理解"],
    characterIds: ["lin-xiaomei", "chen-laogen", "chen-xiaoli", "chen-jianguo"],
  },
  {
    id: "4",
    number: 4,
    title: "亲家母到访",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20two%20middle%20aged%20chinese%20women%20meeting%20politely%20at%20a%20courtyard%20gate%20carrying%20gift%20baskets%2C%20courteous%20yet%20tense%20expressions%2C%20soft%20afternoon%20lighting%2C%20muted%20warm%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-04&orientation=portrait",
    airDate: "2024-03-04",
    duration: "45分钟",
    director: "张建安",
    cast: ["孙慧敏", "李国强", "周雨桐"],
    summary: "林晓梅的母亲千里迢迢赶来，两亲家的第一次会面客套之下暗藏机锋。",
    plot: "林母从南方坐了十几个小时的车来看女儿，一进院子就心疼地发现女儿瘦了。两家人坐在堂屋里喝茶，表面上客客气气，话里却句句有别。林母委婉地提起女儿在医院工作辛苦，陈老根则强调陈家的规矩。夹在中间的陈建国手足无措。晚上，林母拉着女儿的手说：“妈不是让你为难，妈只是想知道你过得好不好。”这句话让林晓梅红了眼眶。",
    tags: ["亲情", "冲突", "两地"],
    characterIds: ["lin-mu", "lin-xiaomei", "chen-laogen", "wang-guifen"],
  },
  {
    id: "5",
    number: 5,
    title: "老房子的秘密",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20an%20old%20chinese%20wooden%20trunk%20being%20opened%20in%20a%20dusty%20attic%20with%20light%20streaming%20through%20a%20small%20window%2C%20mysterious%20nostalgic%20mood%2C%20muted%20amber%20tones%2C%20soft%20film%20grain%2C%20emotional%20harmonious%20composition&width=600&height=900&seq=ep-cover-05&orientation=portrait",
    airDate: "2024-03-05",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "陈志远", "赵雅琴"],
    summary: "陈建国在阁楼整理旧物时，翻出了母亲留下的一封未寄出的信。",
    plot: "林晓梅想把阁楼收拾出来给儿子当书房，陈建国爬上梯子搬那些积灰的木箱。最底下一只上锁的旧木匣里，放着母亲生前写给父亲的一封信，信纸已经泛黄。信里写着母亲当年也曾被陈家的规矩委屈过，却选择用一碗碗热汤把家人拢在一起。陈建国把信读给陈老根听，老人背过身去，肩膀微微颤抖。这封信，像一把钥匙，悄悄打开了父子之间紧闭多年的门。",
    tags: ["温情", "回忆", "和解"],
    characterIds: ["chen-laogen", "chen-jianguo", "chen-xiaoli", "lin-xiaomei"],
  },
  {
    id: "6",
    number: 6,
    title: "孙子的心愿",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20little%20chinese%20boy%20writing%20a%20wish%20letter%20at%20a%20wooden%20desk%20by%20a%20window%2C%20soft%20morning%20light%2C%20hopeful%20tender%20mood%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-06&orientation=portrait",
    airDate: "2024-03-06",
    duration: "45分钟",
    director: "张建安",
    cast: ["郑一鸣", "李国强", "王秀兰"],
    summary: "陈小宇在作文里写下心愿：“希望爷爷和妈妈能一起笑。”",
    plot: "学校布置了一篇《我的心愿》的作文。陈小宇写下的不是玩具也不是旅行，而是希望爷爷和妈妈能像以前那样一起笑。老师把作文念了出来，陈老根去接孙子放学时恰好听见，站在教室后门愣了很久。回家的路上，爷孙俩谁都没说话。晚饭时，陈老根第一次主动给林晓梅盛了一碗汤，王桂芬看在眼里，偷偷笑了。这个家，好像有什么正在悄悄融化。",
    tags: ["温情", "童真", "家庭"],
    characterIds: ["chen-xiaoyu", "chen-laogen", "wang-guifen", "lin-xiaomei"],
  },
  {
    id: "7",
    number: 7,
    title: "邻里闲话",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20two%20neighborhood%20women%20whispering%20behind%20a%20half%20open%20chinese%20alley%20door%20with%20curious%20expressions%2C%20soft%20daylight%2C%20everyday%20street%20life%20mood%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-07&orientation=portrait",
    airDate: "2024-03-07",
    duration: "45分钟",
    director: "张建安",
    cast: ["刘桂芳", "陈志远", "周雨桐"],
    summary: "赵大婶一句无心的闲话，让陈家一夜之间成了整条巷子的谈资。",
    plot: "巷口的赵大婶最爱打听各家的事，听说了陈家儿媳搬回来的消息，添油加醋地传了出去，说陈家儿子“娶了媳妇忘了爹”。这些话传到陈老根耳朵里，老人脸上挂不住，回家摔了茶杯。陈建国去找赵大婶理论，反被噎了回来。林晓梅却只是平静地把院子门关上，对丈夫说：“别人怎么说，跟我们过得好不好没关系。”她的镇定，让这个风波的底线守住了。",
    tags: ["邻里", "误会", "冲突"],
    characterIds: ["zhao-dashen", "chen-laogen", "chen-jianguo", "lin-xiaomei"],
  },
  {
    id: "8",
    number: 8,
    title: "一场误会",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20an%20angry%20elderly%20chinese%20man%20turning%20away%20from%20a%20hurt%20young%20woman%20in%20a%20dim%20living%20room%2C%20tense%20emotional%20moment%2C%20muted%20moody%20amber%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-08&orientation=portrait",
    airDate: "2024-03-08",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "周雨桐", "孙慧敏"],
    summary: "陈老根误以为儿媳要卖掉老宅，一场积压已久的争吵终于爆发。",
    plot: "林母劝女儿帮陈老根的老宅办个房产手续，免得日后麻烦。中介来家里拍照的场景被陈老根撞见，老人立刻认定是这个儿媳要把他扫地出门。积压了两个月的委屈和防备在这一刻全部爆发，父子、翁媳在堂屋里吵作一团。林晓梅终于没忍住，红着眼说：“爸，我从来没想过要赶您走。”吵到最后，谁也没吃东西，堂屋的灯亮了一整夜。",
    tags: ["冲突", "误会", "爆发"],
    characterIds: ["chen-laogen", "lin-xiaomei", "lin-mu", "chen-jianguo"],
  },
  {
    id: "9",
    number: 9,
    title: "小姑出头",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20determined%20young%20chinese%20woman%20standing%20up%20protecting%20another%20woman%20in%20a%20family%20argument%2C%20defiant%20expression%2C%20soft%20evening%20lighting%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-09&orientation=portrait",
    airDate: "2024-03-09",
    duration: "45分钟",
    director: "张建安",
    cast: ["赵雅琴", "周雨桐", "李国强"],
    summary: "陈晓丽当着全家的面替嫂子说话，把那个“外人”的标签撕了下来。",
    plot: "冷战的第三天，陈晓丽从学校赶回家，把全家叫到堂屋。她翻出嫂子这两个月为这个家做的事：记下爷爷爱吃的东西、帮奶奶去配老花镜、悄悄给哥哥的工地送饭。她一句一句讲给大家听，最后转头对陈老根说：“爸，嫂子要是外人，那谁是家里人？”堂屋里安静下来。陈老根看着面前这个倔强的女儿，又看看低头不语的儿媳，长长叹了口气。",
    tags: ["和解", "亲情", "仗义"],
    characterIds: ["chen-xiaoli", "lin-xiaomei", "chen-laogen", "chen-jianguo"],
  },
  {
    id: "10",
    number: 10,
    title: "婆婆的心事",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20an%20older%20chinese%20woman%20quietly%20folding%20laundry%20alone%20by%20a%20window%20with%20a%20wistful%20expression%2C%20soft%20afternoon%20light%2C%20gentle%20melancholic%20mood%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-10&orientation=portrait",
    airDate: "2024-03-10",
    duration: "45分钟",
    director: "张建安",
    cast: ["王秀兰", "郑一鸣", "周雨桐"],
    summary: "王桂芬突然病倒，全家人才发现这个总在唠叨的人一直默默扛着一切。",
    plot: "王桂芬在厨房忙到一半突然晕倒，被送进医院。林晓梅守在病床前，翻出王桂芬的记事本，上面密密麻麻记着全家人的药、菜价和琐事，却唯独没有一句关于自己。陈小宇趴在床边问奶奶是不是太累了。王桂芬醒来后第一句话竟是“晚饭还没做呢”。这一集里，那个一直被人嫌唠叨的婆婆，第一次让人心疼得说不出话。",
    tags: ["温情", "健康", "亲情"],
    characterIds: ["wang-guifen", "lin-xiaomei", "chen-xiaoyu"],
  },
  {
    id: "11",
    number: 11,
    title: "装修风波",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20half%20renovated%20traditional%20chinese%20house%20with%20scaffolding%20and%20paint%20buckets%2C%20family%20members%20discussing%20plans%2C%20soft%20daylight%2C%20lively%20everyday%20mood%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-11&orientation=portrait",
    airDate: "2024-03-11",
    duration: "45分钟",
    director: "张建安",
    cast: ["陈志远", "李国强", "刘桂芳"],
    summary: "陈建国想把老宅翻新，父亲却坚持一砖一瓦都不能动。",
    plot: "陈建国的装修队接了活儿，顺手想给自家老宅翻新一下，可陈老根坚决不同意动院里那面刻着老槐树影子的青砖墙。父子俩为这事僵住了。赵大婶在门口看了半天热闹，临走时却说了一句实在话：“房子是给人住的，别为房子伤了人心。”这句话让陈建国冷静下来，也让他第一次认真去想，父亲守着的到底是什么。",
    tags: ["冲突", "家庭", "邻里"],
    characterIds: ["chen-jianguo", "chen-laogen", "zhao-dashen", "lin-xiaomei"],
  },
  {
    id: "12",
    number: 12,
    title: "女儿的决定",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20thoughtful%20chinese%20woman%20looking%20out%20of%20a%20train%20window%20at%20a%20passing%20countryside%2C%20reflective%20mood%2C%20soft%20golden%20light%2C%20muted%20warm%20tones%2C%20nostalgic%20atmosphere%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-12&orientation=portrait",
    airDate: "2024-03-12",
    duration: "45分钟",
    director: "张建安",
    cast: ["周雨桐", "孙慧敏", "李国强"],
    summary: "林晓梅收到了南方老家的工作机会，一个关于“走”还是“留”的选择摆在她面前。",
    plot: "林晓梅收到老家医院的调函，条件优厚，母亲在电话里劝她回来。她站在院子里，看着陈老根教孙子写毛笔字，看着王桂芬在厨房里忙碌的背影，心里第一次犹豫了。晚上她和陈建国长谈，丈夫说：“你想回，我不拦你，但我想让你知道，这个家现在也需要你。”林晓梅一夜未眠，第二天，她把调函收进了抽屉。她选择了留下，但这次不是委屈，而是甘愿。",
    tags: ["抉择", "亲情", "成长"],
    characterIds: ["lin-xiaomei", "lin-mu", "chen-laogen", "chen-jianguo"],
  },
  {
    id: "13",
    number: 13,
    title: "深夜的长谈",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20father%20and%20son%20sitting%20on%20a%20courtyard%20step%20talking%20under%20a%20warm%20outdoor%20lamp%20at%20night%2C%20intimate%20honest%20mood%2C%20muted%20amber%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-13&orientation=portrait",
    airDate: "2024-03-13",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "陈志远", "赵雅琴"],
    summary: "陈老根第一次向儿子松口，讲起了自己和老伴年轻时的故事。",
    plot: "那天夜里，陈老根睡不着，坐在院子里的台阶上抽烟。陈建国端了碗热茶坐过去。父子俩多少年没这么安静地待过。陈老根讲起当年老伴进门时也受过委屈，讲自己为什么总把话憋在心里，讲到动情处，声音有些发哑。“你妈当年比晓梅还倔，”老人说，“可她把这个家撑起来了。”陈建国听着，第一次真切地理解了父亲。这一夜，隔在两人之间的那堵墙，塌了。",
    tags: ["和解", "父子", "回忆"],
    characterIds: ["chen-laogen", "chen-jianguo", "chen-xiaoli"],
  },
  {
    id: "14",
    number: 14,
    title: "病中的照顾",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20young%20chinese%20woman%20gently%20caring%20for%20a%20sick%20elderly%20man%20in%20bed%20with%20a%20bowl%20of%20soup%2C%20tender%20devoted%20mood%2C%20soft%20warm%20lighting%2C%20muted%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-14&orientation=portrait",
    airDate: "2024-03-14",
    duration: "45分钟",
    director: "张建安",
    cast: ["周雨桐", "李国强", "王秀兰"],
    summary: "陈老根病倒了，林晓梅衣不解带地守在床边，把那些误会一碗一碗喂了下去。",
    plot: "换季时节，陈老根的老寒腿和胃病一起犯了，高烧不退。林晓梅是护士，请了假守在床边，按时喂药、擦身、换被单。夜里陈老根迷迷糊糊地喊老伴的名字，林晓梅轻声应着，握住他的手。烧退的那天早上，陈老根睁开眼，看见守在床边睡着的儿媳，第一次觉得，这个家里，早就没有什么“外人”了。",
    tags: ["温情", "照顾", "和解"],
    characterIds: ["lin-xiaomei", "chen-laogen", "wang-guifen"],
  },
  {
    id: "15",
    number: 15,
    title: "老照片",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20family%20spread%20of%20old%20faded%20photographs%20on%20a%20wooden%20table%20being%20looked%20at%20by%20hands%2C%20nostalgic%20mood%2C%20soft%20afternoon%20light%2C%20muted%20sepia%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-15&orientation=portrait",
    airDate: "2024-03-15",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "陈志远", "刘桂芳"],
    summary: "一张泛黄的全家福，牵出了陈老根和老街坊之间几十年的情谊。",
    plot: "赵大婶送来一张压在箱底的老照片，上面是二十年前的巷子口，年轻的陈老根和老邻居们挤在一起笑。陈老根摩挲着照片，第一次跟儿子讲起当年的老街故事，讲起那些搬走的、离开的、再也回不来的人。陈建国忽然明白，父亲守着的不是一面墙，而是一整段回不去的时光。他决定，把老宅的墙留下来，把院子修好。",
    tags: ["回忆", "邻里", "温情"],
    characterIds: ["chen-laogen", "zhao-dashen", "chen-jianguo"],
  },
  {
    id: "16",
    number: 16,
    title: "亲家之间的约定",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20two%20older%20chinese%20people%20shaking%20hands%20over%20a%20tea%20table%20in%20a%20sunlit%20courtyard%2C%20warm%20reconciled%20expressions%2C%20soft%20daylight%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-16&orientation=portrait",
    airDate: "2024-03-16",
    duration: "45分钟",
    director: "张建安",
    cast: ["孙慧敏", "李国强", "周雨桐"],
    summary: "林母再次登门，这次两位老人坐在一张桌子前，认认真真地把话说开了。",
    plot: "林母再来时，带的不再是挑剔，而是一篮子南方特产。两位老人坐在院子里的藤椅上，从孩子的婚事聊到各自的难处，聊到彼此年轻时的经历，竟然越聊越投缘。陈老根第一次主动向林母道歉，林母也坦言自己护女心切。两个家庭在这一天定下约定：以后孩子们的事，两家一起商量。林晓梅站在屋里看着这一幕，眼角湿了。",
    tags: ["和解", "亲情", "两家人"],
    characterIds: ["lin-mu", "chen-laogen", "lin-xiaomei", "wang-guifen"],
  },
  {
    id: "17",
    number: 17,
    title: "各退一步",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20family%20walking%20together%20along%20a%20tree%20lined%20chinese%20street%20at%20golden%20hour%2C%20each%20carrying%20something%2C%20warm%20hopeful%20mood%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-17&orientation=portrait",
    airDate: "2024-03-17",
    duration: "45分钟",
    director: "张建安",
    cast: ["陈志远", "赵雅琴", "周雨桐"],
    summary: "为了孙子上学和婆婆养老，一家人第一次围坐在一起，学着为彼此让步。",
    plot: "陈小宇要升初中，学区、老宅、老人的照料成了绕不开的难题。一家人头一回真正坐下来开会，不再是各说各话。陈建国提出在城里租房，陈老根却主动说不必搬，自己身子骨还硬朗。林晓梅提议周末来回跑，陈晓丽抢着说自己可以接送侄子。没有人被落下，也没有人被勉强。这个家，终于学会了什么叫各退一步，才能一起往前走。",
    tags: ["家庭", "成长", "温情"],
    characterIds: ["chen-jianguo", "chen-xiaoli", "lin-xiaomei", "chen-xiaoyu"],
  },
  {
    id: "18",
    number: 18,
    title: "生日惊喜",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20cozy%20surprise%20birthday%20gathering%20in%20a%20chinese%20courtyard%20with%20small%20candles%20and%20a%20cake%2C%20warm%20joyful%20happy%20mood%2C%20muted%20amber%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-18&orientation=portrait",
    airDate: "2024-03-18",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "周雨桐", "郑一鸣"],
    summary: "全家人瞒着陈老根张罗了一场生日宴，老人笑着笑着就湿了眼眶。",
    plot: "陈老根的生日，谁也没敢提前说。林晓梅订了个不甜的蛋糕，陈小宇画了张贺卡，王桂芬做了一桌老人爱吃的菜。当堂屋的灯突然亮起、一家人齐声唱起生日歌时，陈老根愣在门口，半天说不出话。他吹蜡烛前许了个愿，没说出口。后来陈小宇偷偷问爷爷许了什么愿，老人摸摸孙子的头说：“愿我们一家人，年年都有这顿饭。”",
    tags: ["温情", "团聚", "家庭"],
    characterIds: ["chen-laogen", "lin-xiaomei", "chen-xiaoyu", "wang-guifen"],
  },
  {
    id: "19",
    number: 19,
    title: "老屋要拆了",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20an%20elderly%20chinese%20man%20standing%20in%20front%20of%20his%20old%20courtyard%20house%20marked%20for%20demolition%2C%20quiet%20resolute%20grief%2C%20soft%20overcast%20light%2C%20muted%20warm%20tones%2C%20soft%20film%20grain%2C%20emotional%20harmonious%20composition&width=600&height=900&seq=ep-cover-19&orientation=portrait",
    airDate: "2024-03-19",
    duration: "45分钟",
    director: "张建安",
    cast: ["李国强", "陈志远", "刘桂芳"],
    summary: "老巷子被列入改造计划，陈家老宅面临拆迁，一家人的心被重新拧在一起。",
    plot: "一纸通知贴在了巷口，老宅所在的地块要改建。消息传来，整个巷子都炸了锅。赵大婶急得四处打听，陈老根却出奇地平静，只在院子里那面青砖墙前站了很久。陈建国担心父亲想不开，整夜陪着。老人却拍拍儿子的肩说：“房子没了可以再有，家不能散。”这句话让陈建国忽然觉得，父亲真的老了，也真的想通了。",
    tags: ["变故", "家庭", "邻里"],
    characterIds: ["chen-laogen", "chen-jianguo", "zhao-dashen", "lin-xiaomei"],
  },
  {
    id: "20",
    number: 20,
    title: "团圆",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20drama%20poster%20of%20a%20large%20three%20generation%20chinese%20family%20celebrating%20together%20in%20a%20new%20bright%20home%20around%20a%20full%20table%2C%20joyful%20tearful%20warm%20mood%2C%20muted%20red%20and%20amber%20tones%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=600&height=900&seq=ep-cover-20&orientation=portrait",
    airDate: "2024-03-20",
    duration: "50分钟",
    director: "张建安",
    cast: ["李国强", "周雨桐", "陈志远"],
    summary: "搬进新家后的第一顿年夜饭，公公与儿媳并排坐在了一起。",
    plot: "老宅拆迁后，一家人搬进了带着大阳台的新房，可陈老根坚持把院里那面青砖墙的一块砖带了出来，垒在了新家的花坛边。除夕这天，全家围坐一桌，林晓梅给公公盛了第一碗汤，陈老根把它喝完，第一次当众说：“这个儿媳妇，是我们陈家的福气。”窗外烟花亮起，一屋子的笑声里，这个历经磨合的家，终于真正团圆了。公公与儿媳的故事，到这里告一段落，而一家人的日子，还在继续。",
    tags: ["团圆", "温情", "大结局"],
    characterIds: ["chen-laogen", "lin-xiaomei", "chen-jianguo", "wang-guifen", "chen-xiaoli", "chen-xiaoyu", "lin-mu"],
  },
];